module.exports = __webpack_public_path__ + "static/media/dark_circle.be77990f.svg";